import {FC, useState} from 'react';
//mui
import {Box, Typography} from '@mui/material';
//constants
import {SUBTITLE1, TEXT, PRIMARY, ADD_DONOR, DONORS} from '@/utils/constants';
//icons
import {ReactComponent as PlusIcon} from '@/assets/icons/plus.svg';
//components
import Button from '@/shared/components/Button';
import DonorsList from './DonorsList';
//styles
import {auctionDonorsStyle} from './AuctionDonors.styles';

const AuctionDonors: FC = () => {
	const [isOpenDonorModal, setIsOpenDonorModal] = useState(false);

	const handleChangeAddDonorModal = () => setIsOpenDonorModal(!isOpenDonorModal);

	return (
		<Box>
			<Typography variant={SUBTITLE1} sx={auctionDonorsStyle.title}>
				{DONORS}
			</Typography>

			<DonorsList isModalOpen={isOpenDonorModal} onModalChange={handleChangeAddDonorModal} />

			<Button
				title={ADD_DONOR}
				variant={TEXT}
				color={PRIMARY}
				startIcon={<PlusIcon />}
				sx={auctionDonorsStyle.button}
				onClick={handleChangeAddDonorModal}
				disableRipple
			/>
		</Box>
	);
};

export default AuctionDonors;
